import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import type { ICall } from './Call.interface';

export default class Call extends Root implements ICall {
  uuid: string;
  idWorkflow: string;
  idTicket: string;
  idContact: string;
  idRecipients: Array<string>;
  note: string;
  contactName: string;
  source: string;
  destination: string;
  recording: string;
  duration: number;
  isIncoming: boolean;
  isAnswered: boolean;
  isRecorded: boolean;
  isSaved: boolean;

  static build = (data: ICall) => new Call(data);
  static blank = () => new Call({ isActive: true });

  /**
   * Constructor
   * @param {ICall} data
   */
  constructor(data?: ICall) {
    super(DocType.of('__datum.call'), data);

    this.uuid = toUUID(data?.uuid);
    this.idWorkflow = toUUID(data?.idWorkflow);
    this.idTicket = toUUID(data?.idTicket);
    this.idContact = toUUID(data?.idContact);
    this.idRecipients = compact(map(data?.idRecipients, (obj) => toUUID(obj)));
    this.note = data?.note || '';
    this.contactName = data?.contactName || '';
    this.source = data?.source || '';
    this.destination = data?.destination || '';
    this.recording = data?.recording || '';
    this.duration = parseInt(data?.duration || 0, 10) || 0;
    this.isIncoming = data?.isIncoming === true;
    this.isAnswered = data?.isAnswered === true;
    this.isRecorded = data?.isRecorded === true;
    this.isSaved = data?.isSaved === true;
  }
}
